import React, { useState } from "react";
import SearchBar from "../Components/SearchBar";
import Navbar from "../Components/Navbar";
import HalfHero from "../Images/main.jpg";
import ApiServiceGrid from "../Components/ApiServiceGrid";
import FilterSideBar from "../Components/FilterSideBar";
import SEO from "../Components/Seo.jsx";

const Services = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const categoryList = [
    "Accounting & CA",
    "Automobiles / Auto Parts",
    "Book / Stationery Store",
    "Chemicals & Fertilizers",
    "Coaching & Training",
    "Computer Equipment & Softwares",
    "Construction Materials & Equipment",
    "Dairy Farm Products / Poultry",
    "Electrical & Electronics Equipment",
    "Entertainment",
    "FMCG Products",
    "Fashion Accessory / Cosmetics",
    "Fitness Center",
    "Footwear",
    "Fruit and Vegetable",
    "Furniture",
    "Garment / Fashion & Hosiery",
    "Gifts & Toys",
    "Hardware Store",
    "Industrial Machinery & Equipment",
    "Interior Designer",
    "Jewellery & Gems",
    "Kirana / General Merchant",
    "Laundry / Washing / Dry Clean",
    "Liquor Store",
    "Mobile & Accessories",
    "NGO & Charitable Trust",
    "Nursery / Plants",
    "Oil & Gas",
    "Paper & Paper Products",
    "Petroleum Bulk Stations & Terminals",
    "Pharmacy / Medical",
    "Real Estate",
    "Renting & Leasing",
    "Repairing / Plumbing / Electrician",
    "Restaurant / Hotel",
    "Salon & Spa",
    "Services",
    "Sweet Shop / Bakery",
    "Tailoring / Boutique",
    "Tours & Travels",
  ];

  return (
    <>
      <SEO
        title="All Categories – OIM"
        description="Browse all businesses listed under OIM"
        categories={categoryList}
      />
      <section className="relative w-full h-1/2 overflow-hidden">
        {/* Background Image (with blur) */}
        <img
          src={HalfHero}
          alt="Hero Background"
          className="absolute inset-0 w-full h-full object-cover z-[-10] blur-sm"
        />

        {/* Navbar */}
        <Navbar />

        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black/70 z-[-5]" />

        {/* Content on top of image */}
        <div className="relative z-10 h-full text-white flex flex-col justify-center items-center">
          <div className="h-3/4 w-3/4 text-white flex flex-col justify-center items-center gap-5">
            <h1 className="text-xl font-bold text-center mulish-light uppercase">
              Welcome to <br />
              <span className="text-xl font-bold md:text-5xl md:mulish-bold tracking-wider bg-gradient-to-r from-orange-500 via-white to-green-500 bg-clip-text text-transparent ">
                ONLINE INDIAN MARKET
              </span>
            </h1>
            <p className="mt-0 md:mt-2 text-sm mulish-light tracking-wider text-center uppercase">
              Get the Nearest and Best Services in the Market.
            </p>
            <SearchBar />
            <div className="flex flex-row justify-around w-3/4"></div>
          </div>
        </div>
      </section>
      <section className="flex flex-col justify-center px-3 md:px-10 items-center bg-gray-100">
        <div className="w-full flex flex-col md:flex-row justify-center items-center md:items-start mt-4 ">
          {/* Sidebar - 1/4 width */}
          {/* Mobile toggle button */}
          <button
            onClick={() => setIsSidebarOpen(true)}
            className="md:hidden px-3 py-1 bg-blue-500 text-white text-sm rounded-md shadow "
          >
            Filters
          </button>
          <div className="w-1/4 z-50 sticky top-0 p-0">
            {/* Sidebar */}
            <FilterSideBar
              isOpen={isSidebarOpen}
              onClose={() => setIsSidebarOpen(false)}
            />
          </div>

          <div className=" md:w-3/4 my-2 md:my-6 w-full space-y-6">
            {/* API-backed results */}
            <ApiServiceGrid />
          </div>
        </div>
      </section>
    </>
  );
};

export default Services;
